module.exports = __webpack_public_path__ + "img/r-220.6bb85342.jpg";